// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { InstrumentSpecificType } from '../Instruments/InstrumentSpecificType';
import { HistoryType } from './HistoryType';
import { TFInfo } from './TFInfo';
export var HistorySortOrder;
(function (HistorySortOrder) {
    HistorySortOrder[HistorySortOrder["Ascending"] = 0] = "Ascending";
    HistorySortOrder[HistorySortOrder["Descending"] = 1] = "Descending";
})(HistorySortOrder || (HistorySortOrder = {}));
export class ReloadHistoryParams {
    constructor(hp = undefined) {
        this.count = undefined;
        this.rightBarsCount = undefined;
        this.isIgnoreAccount = false;
        this.UseDefaultInstrumentHistoryType = false;
        this.FromTime = null;
        this.ToTime = null;
        this.InstrumentID = -1;
        this.IsContinuous = false;
        this.InstrumentTradableID = null;
        this.InstrumentFullName = '';
        this.Plan = null;
        this.NeedApplySpreadPlan = false;
        this.NeedLoadSecondPartOfHistory = false;
        /**
         * Aggregated by server if true
         */
        this.ShouldCheckAggregatedPeriods = false;
        this.sortOrder = HistorySortOrder.Descending;
        this.fill(hp);
    }
    fill(hp) {
        this.TimeFrameInfo = new TFInfo();
        if (hp === undefined) {
            return;
        }
        this.count = hp.count;
        this.rightBarsCount = hp.rightBarsCount;
        this.callBack = hp.callBack;
        this.userPin = hp.userPin;
        this.route = hp.route;
        this.UseDefaultInstrumentHistoryType = hp.UseDefaultInstrumentHistoryType;
        this.FromTime = hp.FromTime;
        this.ToTime = hp.ToTime;
        this.TimeFrameInfo = hp.TimeFrameInfo.Copy();
        this.symbol = hp.symbol;
        this.userId = hp.userId;
        this.InstrumentID = hp.InstrumentID;
        this.IsContinuous = hp.IsContinuous;
        this.Instrument = hp.Instrument;
        this.InstrumentTradableID = hp.InstrumentTradableID;
        this.InstrumentFullName = hp.InstrumentFullName;
        this.Plan = hp.Plan;
        this.NeedApplySpreadPlan = hp.NeedApplySpreadPlan;
        this.NeedLoadSecondPartOfHistory = hp.NeedLoadSecondPartOfHistory;
        this.ShouldCheckAggregatedPeriods = hp.ShouldCheckAggregatedPeriods;
        this.sortOrder = hp.sortOrder;
    }
    updateWithProps(props) {
        this.updateAccount(props.account);
        this.updateInstrument(props.instrument);
        this.updateTimeFrameInfo(props.TimeFrameInfo, props.onlyMainSession);
        if (props.FromTime != null) {
            this.FromTime = props.FromTime;
        }
        if (props.ToTime != null) {
            this.ToTime = props.ToTime;
        }
        if (props.count != null) {
            this.count = props.count;
        }
        if (props.UseDefaultInstrumentHistoryType != null) {
            this.UseDefaultInstrumentHistoryType = props.UseDefaultInstrumentHistoryType;
        }
        if (props.sortOrder != null) {
            this.sortOrder = props.sortOrder;
        }
        if (props.rightBarsCount != null) {
            this.rightBarsCount = props.rightBarsCount;
        }
        if (props.isIgnoreAccount != null) {
            this.isIgnoreAccount = props.isIgnoreAccount;
        }
    }
    updateAccount(account) {
        if (account != null) {
            this.userPin = account === null || account === void 0 ? void 0 : account.userPin;
            this.userId = account === null || account === void 0 ? void 0 : account.userID;
        }
    }
    updateInstrument(instrument) {
        if (instrument != null) {
            this.symbol = instrument.ShortName;
            this.route = instrument.Route;
            this.InstrumentFullName = instrument.GetInteriorID();
            this.IsContinuous = instrument.InstrumentSpecificType === InstrumentSpecificType.ContinuousContract;
            this.InstrumentTradableID = instrument.InstrumentTradableID;
            this.InstrumentID = parseInt(instrument.Id);
            this.Instrument = instrument;
        }
    }
    updateTimeFrameInfo(tfInfo, onlyMainSession) {
        var _a, _b;
        if (tfInfo != null) {
            this.TimeFrameInfo = tfInfo;
            this.Plan = this.TimeFrameInfo.Plan;
            this.NeedApplySpreadPlan = this.calculateNeedApplySpreadPlan();
            this.NeedLoadSecondPartOfHistory =
                (_b = (_a = this.Plan) === null || _a === void 0 ? void 0 : _a.IsNeedLoadHistoryForSpread(this.Instrument, this.TimeFrameInfo.HistoryType)) !== null && _b !== void 0 ? _b : false;
            if (onlyMainSession != null) {
                this.TimeFrameInfo.SessionInfo.OnlyMainSession = onlyMainSession;
            }
        }
    }
    calculateNeedApplySpreadPlan() {
        return (this.Plan !== null &&
            this.Plan.IsNotEmptyPlan(this.Instrument) &&
            this.TimeFrameInfo.HistoryType !== HistoryType.LAST);
    }
    static createFrom(props) {
        const historyParams = new ReloadHistoryParams();
        historyParams.updateWithProps(props);
        historyParams.Account = props.account;
        return historyParams;
    }
}
